export interface PlusgradeRequest {
  lastName: string;
  origin: PlusgradeCallOrigin;
  pnr: string;
}

export enum PlusgradeCallOrigin {
  TRIPS,
  MARKETING,
}
